import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container flex h-full items-center justify-between border-white/30 lg:border-b" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

import BizIcon from '@/components/base/BizIcon.vue';
import { onMounted, onUnmounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FaqHeader',
  props: {
    homeLink: null,
    editMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { homeLink: string; editMode: boolean }


const transparent = ref(true);
const showNavi = ref(true);
let lastScrollPos = 0;

onMounted(() => {
    document.addEventListener('scroll', onScroll, { passive: false });
});

onUnmounted(() => {
    document.removeEventListener('scroll', onScroll);
});

function onScroll() {
    if (props.editMode) {
        return;
    }
    const scrollPos = Math.max(document.scrollingElement.scrollTop, 0);
    transparent.value = scrollPos === 0;
    showNavi.value = scrollPos <= lastScrollPos;
    lastScrollPos = scrollPos;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["fixed left-0 top-0 z-50 h-16 w-full transition-all duration-1000 lg:h-18", [
            transparent.value ? 'border-transparent' : 'border-gray-100',
            { '-translate-y-full': !showNavi.value }
        ]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["h-full bg-gradient-to-b transition-colors duration-500", [transparent.value ? 'bg-transparent text-white' : 'bg-white']])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          href: __props.homeLink,
          class: _normalizeClass([transparent.value ? 'text-white' : 'text-gray-500'])
        }, [
          _createVNode(BizIcon, {
            name: "bizerba-logo",
            class: "h-4 fill-current lg:h-5"
          })
        ], 10, _hoisted_2),
        _hoisted_3
      ])
    ], 2)
  ], 2))
}
}

})